﻿window.lstFuncUpdateReservationHebergementPuttc = []
window.inExeFuncUpdateReservationHebergementPuttc = false
window.cObjetReservationHebergementMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "Réservation hébergement"; }
    this.mGetAttributBase = function () { return "la " }
    this.mGetNewLib = function () { return "Nouvel réservation hébergement"; }
    this.mGetLib1 = function (option) {
        return "Réservation hébergement"
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-bell-concierge' style='position:relative'><i class='fas fa-person-shelter dx-theme-accent-as-text-color' style='position:absolute;bottom:0;right:0;font-size:60%;'></i></i>");
    }

    this.mGetLstReservationHebergementFromDate = function (dat1, dat2) {
        //var dattt = new Date()
        //const limit = dat2 ?? dat1;   // on cherche date_debut <= limit
        //var result = [];
        //for (const r of objet.bddRef.mGetArray("reservation_hebergement")) {
        //    if (r.date_debut > limit) break;   // 🔑 sortie anticipée
        //    if (dat2 ? dat1 <= r.date_fin : dat1 <= r.date_fin && dat1 >= r.date_debut)
        //        result.push(r);
        //}
        //var diff1 = Math.abs(+new Date() - +dattt)
        //dattt = new Date
        var result = Me.objet.bddRef.mGetArray("reservation_hebergement").filter(function (resaHeberg) {
            if (dat2) {
                return (dat2 >= resaHeberg.date_debut && dat1 <= resaHeberg.date_fin)
            } else {
                return dat1 <= resaHeberg.date_fin && dat1 >= resaHeberg.date_debut
            }
        })
        //var diff2 = Math.abs(+new Date() - +dattt)
        //console.log(diff1 + " / "+ diff2)
        return result;
    }
    this.mGetNbJourChevauche = function (dat1, dat2) {
        // Déterminer la date de début la plus tardive
        const start = new Date(Math.max(dat1.getTime(), objet.data.date_debut.getTime()));
        // Déterminer la date de fin la plus précoce
        const end = new Date(Math.min(dat2.getTime(), objet.data.date_fin.getTime()));

        // Si start > end, il n'y a pas de chevauchement
        if (start > end) {
            return 0;
        }

        // Calculer le nombre de jours entre start et end (inclus)
        const timeDiff = end.getTime() - start.getTime();
        const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24)) + 1; // +1 pour inclure les deux dates
        return daysDiff;
    }
    this.mGetLstReservationHebergementLinkedForVirtuel = function () {
        return Me.objet.bddRef.mGetArray("reservation_hebergement").filter(function (resaHeberg) {
            return resaHeberg.id_reservation_hebergement_parent == objet.data.id_reservation_hebergement
        })
    }
    this.mGetLstDataReservationHebergementPuttc = function () {
        return Me.objet.bddRef.mGetArray("reservation_hebergement_puttc").filter(function (resaHebergPuttc) {
            return resaHebergPuttc.id_reservation_hebergement == objet.data.id_reservation_hebergement
        })
    }

    this.mGetReservation = function () {
        return Me.objet.bddRef.mGetArray("reservation").filter(function (o) { return o.id_reservation == objet.data.id_reservation })[0]
    }

    this.mGetHebergement = function () {
        return Me.objet.bddRef.mGetArray("hebergement").filter(function (o) { return o.id_hebergement == objet.data.id_hebergement })[0]
    }

    this.mGetNbNuite = function () {
        return mGetNbNuits(objet.data.date_debut, objet.data.date_fin)
    }
    this.mGetLstJourneesService = function () {
        var lstDate = mGetLstJournees(objet.data.date_debut, objet.data.date_fin)
        //if (!idTypePlageService) { //aucun/indefini
        //    //on compte les nuités et on enlève la dernière journée
        //    lstDate.splice(lstDate.length - 1, 1)
        //} else if (idTypePlageService == 1) { //matin
        //    //on enlève la première journée
        //    lstDate.splice(0, 1)
        //} else if (idTypePlageService == 2) { //midi
        //    //on enleve la première et la dernière date
        //    lstDate.splice(0, 1)
        //    lstDate.splice(lstDate.length - 1, 1)
        //} else { //
        //    //on enlève la dernière date
        //    lstDate.splice(lstDate.length - 1, 1)
        //}
        return lstDate
    }
    this.mGetNbJourneesService = function () {
        return this.mGetLstJourneesService().length
    }

    this.mGetLstDataReservationService = function () {
        return objet.bddRef.mGetArray("reservation_service").filter(function (o) {
            return o.id_reservation == objet.data.id_reservation && o.id_reservation_hebergement == objet.data.id_reservation_hebergement
        })
    }

    this.mGetNbNuits = function () {
        return mGetNbNuits(objet.data.date_debut, objet.data.date_fin)
    }

    this.mGetLibNuites = function () {
        return mGetLibNuites(objet.data.date_debut, objet.data.date_fin)
        //var dateDeb = objet.data.date_debut
        //var datFin = objet.data.date_fin
        //var nbNuit = this.mGetNbNuits()
        //var formatArrive = d => DevExpress.localization.formatDate(d, "dd/MM/yyyy");
        //const formatDepart = d => DevExpress.localization.formatDate(d, "dd/MM/yyyy");
        //if (dateDeb.getFullYear() == datFin.getFullYear()) {
        //    if (dateDeb.getMonth() == datFin.getMonth()) {
        //        formatArrive = d => DevExpress.localization.formatDate(d, "dd");
        //    } else {
        //        formatArrive = d => DevExpress.localization.formatDate(d, "dd/MM");
        //    }
        //}
        //return "" + dateDeb.dayOfWeekName() + " " + formatArrive(dateDeb) + " → " + datFin.dayOfWeekName() + " " + formatDepart(datFin) + " • " + nbNuit + "<i class='fas fa-moon' title='nuités'></i>"
    }

    this.mGetTotalTtcService = function () {
        var totTtc = 0
        this.mGetLstDataReservationService().forEach(function (dataResaService) {
            totTtc += objet.bddRef.getObjet(dataResaService).objetMetier.mGetTotTtc()
        })
        return totTtc
    }

    this.mGetTotalTtcNuite = function () {
        var totTtc = 0
        this.mGetLstDataReservationHebergementPuttc().forEach(function (dataResaHebergPuttc) {
            totTtc += dataResaHebergPuttc.puttc
        })
        return totTtc
    }

    this.mGetTotalTtc = function () {
        return this.mGetTotalTtcService() + this.mGetTotalTtcNuite()
    }

    this.mGetElementResumeHtml = function () {

    }

    this.mUpdateReservationHebergementPuttc = function (funcEnd) {

        if (inExeFuncUpdateReservationHebergementPuttc) {
            lstFuncUpdateReservationHebergementPuttc.push(function () { Me.mUpdateReservationHebergementPuttc(funcEnd) })
            return
        }

        inExeFuncUpdateReservationHebergementPuttc = true
        var lstDate = mGetLstDateBetween2Dates(objet.data.date_debut, objet.data.date_fin)
        var lstResaHebergPuttc = this.mGetLstDataReservationHebergementPuttc()

        var lstNewCreate = []
        lstDate.forEach(function (dat) {
            var newData = {}
            newData.id_reservation_hebergement = objet.data.id_reservation_hebergement
            newData.dat = dat
            newData.puttc = (objet.data.puttc != null ? objet.data.puttc : objet.bddRef.getObjet(Me.mGetHebergement()).objetMetier.mGetPrixPersonneNuit(dat, objet.data.nb_adulte + objet.data.nb_enfant, Me.mGetNbNuite()))
            lstNewCreate.push(newData)
        })

        //on supprime les dates services qui ne sont plus cohérentes
        var lstDataReservationServiceToDel = []
        this.mGetLstDataReservationService().forEach(function (dataResaService) {
            objet.bddRef.getObjet(dataResaService).objetMetier.mGetLstDataReservationServiceDate().forEach(function (dataReservationServiceDate) {
                if (dataReservationServiceDate.dat < objet.data.date_debut || dataReservationServiceDate.dat > objet.data.date_fin) {
                    lstDataReservationServiceToDel.push(dataReservationServiceDate)
                }
            })
        })

        objet.bddRef.mAjaxCall({
            command: "updateresahebergttc",
            id_reservation_hebergement: objet.data.id_reservation_hebergement,
            lst_new_date: lstNewCreate,
            lst_reservation_service_date_to_del: lstDataReservationServiceToDel
        }, function () {
            lstDataReservationServiceToDel.forEach(function (dataResaServiceDate) {
                objet.bddRef.mDelItemData("reservation_service_date", dataResaServiceDate)
            })
            lstResaHebergPuttc.forEach(function (dataResaHebergPuttc) { objet.bddRef.mDelItemDataWithId("reservation_hebergement_puttc", dataResaHebergPuttc.id_reservation_hebergement_puttc) })
            if (funcEnd) funcEnd()
            inExeFuncUpdateReservationHebergementPuttc = false
            if (lstFuncUpdateReservationHebergementPuttc.length > 0) {
                var func = lstFuncUpdateReservationHebergementPuttc[0]
                lstFuncUpdateReservationHebergementPuttc.splice(0, 1)
                func()
            }
        }, null, function () {
            inExeFuncUpdateReservationHebergementPuttc = false
            if (lstFuncUpdateReservationHebergementPuttc.length > 0) {
                var func = lstFuncUpdateReservationHebergementPuttc[0]
                lstFuncUpdateReservationHebergementPuttc.splice(0, 1)
                func()
            }
        })
    }

    this.mDelData = function (funcOk, option, noRestore, funcRestore, funcAlways, funcKo, defintif) {
        objet.mDelDataInterne(function () {
            var lstData = objet.bddRef.mGetArray("hebergement_agenda_centrale_rdv").filter(function (o) {
                return o.id_reservation_hebergement == objet.data.id_reservation_hebergement
            })
            lstData.forEach(function (data) {
                data.id_reservation_hebergement = null
                objet.bddRef.getObjet(data).mSaveChamp("id_reservation_hebergement")
            })
            objet.bddRef.mGetArray("reservation_hebergement").filter(function (o) {
                return o.id_reservation_hebergement_parent == objet.data.id_reservation_hebergement
            }).forEach(function (dataReservationHeberg) {
                objet.bddRef.mDelItemData("reservation_hebergement", dataReservationHeberg)
            })
            if (funcOk) funcOk()
        }, option, noRestore, funcRestore, funcAlways, funcKo, defintif)
    }

    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {
        var dataReservation = null
        if (objet.data) {
            dataReservation = this.mGetReservation()
        }

        if (!dataReservation) {
            console.log("hebergResa sans resa: " + dataTemplate.id_reservation_hebergement)
            //debugger;
            return;
        }
        var objResa = objet.bddRef.getObjet(dataReservation)

        var contentMiseEnForme = contentElement
        if (contentElement.closest(".divtemplate").length > 0) {
            contentMiseEnForme = contentElement.closest(".divtemplate")
        }
        contentMiseEnForme.addClass("resa_heberg idstatutresa" + objResa.data.id_statut_resa)

        var nbResaHeberg = objResa.objetMetier.mGetLstReservationHebergement().length
        if (nbResaHeberg > 1) {
            contentMiseEnForme.addClass("texture_grp_resa_" + ((objet.data.id_reservation % 10) + 1))
            $("<div style='opacity:0.7;font-size:80%;border-radius:50%;position:absolute;top:-5px;right:25px;background-color:" + theme.backgroundcolorAccent + ";min-width:14px;text-align:center;border:" + theme.border + ";'>" + nbResaHeberg + "</div>").appendTo(contentElement.parent()).attr("title", "<b>" + nbResaHeberg + "</b> hébergement pour cette réservation")
        }

        var $Span = $("<span></span>").appendTo(contentElement)
        if (dataReservation.id_statut_resa != 3) {
            if (objet.data.nb_adulte > 0) {
                $("<span>" + objet.data.nb_adulte + "<i class='fas fa-person'></i></span>").appendTo($Span)
            }
            if (objet.data.nb_enfant > 0) {
                $("<span>" + objet.data.nb_enfant + "<i class='fas fa-child-reaching'></i></span>").appendTo($Span)
            }
            $("<span> &bull; </span>").appendTo($Span)
            if (objet.data.nb_grand_lit > 0) {
                $("<span>" + objet.data.nb_grand_lit + "<i class='fafa-grand-lit'></i></span>").appendTo($Span)
            }
            if (objet.data.nb_petit_lit > 0) {
                $("<span>" + objet.data.nb_petit_lit + "<i class='fafa-petit-lit'></i></span>").appendTo($Span)
            }
            if (objResa.data.from_internet == 1) {
                $("<span> &bull; </span>").appendTo($Span)
                $("<span><i class='fas fa-globe fa-flip'></i></span>").appendTo($Span)
            } else if (objet.data.id_centrale_reservation != null) {
                $("<span> &bull; </span>").appendTo($Span)
                var dataCentrale = objet.bddRef.getObjet("centrale_reservation", objet.data.id_centrale_reservation).data
                $("<span><i class='fas fa-hotel fa-shake'></i></span>").appendTo($Span).attr("title", "Réservation par " + dataCentrale.nom)
            }
        }

        //$("<span style='opacity:0.5;'> &bull; </span>").appendTo($Span)
        //$("<span style='font-size:60%;'>").appendTo($Span).dxCtrlVisuHebergementConfig({
        //    bddCtrl: Me.objet.bddRef,
        //    height: 14,
        //    value: {
        //        nb_grand_lit: objet.data.nb_grand_lit,
        //        nb_petit_lit: objet.data.nb_petit_lit
        //    }
        //})
        if (parseInt(objResa.data.id_statut_resa) != 3) {
            $("<span style='opacity:0.5;'> &bull; </span>").appendTo($Span)
            var libClient = objResa.data.lib_client
            if (libClient) {
                if (dataReservation.code_pays_client && dataReservation.code_pays_client.length > 0) {
                    $("<img style='display:inline_block;padding-right:3px;' src='https://flagcdn.com/16x12/" + dataReservation.code_pays_client.toLowerCase() + ".png'/>").appendTo($Span)
                }
            }
            $("<span>" + (libClient ? libClient : "---") + "</span>").appendTo($Span)
        }
        if (dataReservation.id_statut_resa != 3) $("<span> &bull; </span>").appendTo($Span)
        $("<span>" + Me.mGetHebergement().nom + "</span>").appendTo($Span)
        $("<span> &bull; </span>").appendTo($Span)
        $("<span>" + Me.mGetLibNuites() + "</span>").appendTo($Span)
        var $DivSuite = $("<div style='line-height:1;white-space:normal;'/>").appendTo($Span)
        switch (parseInt(objResa.data.id_statut_resa)) {
            case 0: $("<span>OPTION</span>").appendTo($DivSuite); break;
            case 1: $("<span>ATTENTE ARRHES</span>").appendTo($DivSuite); break;
            case 2: $("<span>CONFIRMÉ</span>").appendTo($DivSuite); break;
            case 3: $("<span>FERMÉ</span>").appendTo($DivSuite); break;
            case 4: $("<span>ANNULÉ</span>").appendTo($DivSuite); break;
            case 5: $("<span><i class='fas fa-cog fa-spin'></i> INTERNET EN COURS</span>").appendTo($DivSuite); break;
        }
        if (dataReservation.commentaire && dataReservation.commentaire.length > 0) {
            $("<span> &bull; </span>").appendTo($DivSuite)
            $("<span style='font-style:italic;font-weight:normal;'></span>").text(dataReservation.commentaire).appendTo($DivSuite)
        }
        if (dataReservation.commentaire_destinataire && dataReservation.commentaire_destinataire.length > 0) {
            $("<span> &bull; </span>").appendTo($DivSuite)
            $("<span style='font-style:italic;font-weight:normal;'></span>").text(dataReservation.commentaire_destinataire).appendTo($DivSuite)
        }
        if (dataTemplate.commentaire && dataTemplate.commentaire.length > 0) {
            $("<span> &bull; </span>").appendTo($DivSuite)
            $("<span style='font-style:italic;font-weight:normal;'></span>").text(dataTemplate.commentaire).appendTo($DivSuite)
        }

        contentElement.attr("title", "<div style='text-align:left;'>" + $Span[0].getHTML() + "</div>")
    }

    this.mGetLibHtmlForResaInternet = function () {
        var txt = this.mGetLibNuites() + "<span> &bull; </span>"
        if (objet.data.nb_adulte > 0) txt += "" + objet.data.nb_adulte + "<i class='fas fa-person' title='adulte'></i>"
        if (objet.data.nb_enfant > 0) txt += (objet.data.nb_adulte > 0 ? " " : "") + "" + objet.data.nb_enfant + "<i class='fas fa-child-reaching'></i>"
        //txt += "<span> &bull; </span>" + this.mGetNbNuite() + " nuité" + (this.mGetNbNuite() > 1 ? "s" : "")
        return txt;
    }

    this.mGetGenereLstDocCptLigneReservation = function () {

        var lstResult = []
        var article = Me.objet.bddRef.mGetArray("article").filter(function (o) { return o.id_article == 803 })[0]
        var lstDateGroupe = mGetLstGrpNuite()
        lstDateGroupe.forEach(function (resumeData) {
            var objArticle = Me.objet.bddRef.getObjet(article)
            var dataLigne = Me.objet.bddRef.getObjet("doc_cpt_ligne").mGetNewData()
            dataLigne.note = ""
            dataLigne.nom_article = ((article.nom == null) ? "" : article.nom) + " <span style='font-size:80%;'>(" + Me.mGetHebergement().nom + ")</span>"
            dataLigne.id_article = article.id_article
            dataLigne.qte = resumeData.nb
            dataLigne.id_hebergement = objet.data.id_hebergement
            dataLigne.date_service = resumeData.dateDebut

            dataLigne.id_tva = Me.objet.bddRef.getObjet("tva").objetMetier.mGetTvaTaux0().id_tva
            var tauxTva = 0
            if (Me.objet.bddRef.mGetArray("societe")[0].assujetti_tva == "1") {
                var dataTva = objArticle.objetMetier.mGetDataTva()
                if (typeof dataTva != 'undefined') {
                    if (Me.objet.bddRef.mGetArray("societe")[0].assujetti_tva == "1") {
                        dataLigne.id_tva = dataTva.id_tva
                        tauxTva = Me.objet.bddRef.getObjet(dataTva).objetMetier.mGetTauxTva()
                    }
                }
            }
            dataLigne.puht = resumeData.ttc
            dataLigne.puttc = resumeData.ttc
            if (tauxTva != 0) dataLigne.puht = Math.round(dataLigne.puht / (1 + tauxTva / 100) * 10000) / 10000
            dataLigne.type_remise = 0
            lstResult.push(dataLigne)
        })

        return lstResult
        //var article = Me.objet.bddRef.mGetArray("article").filter(function (o) { return o.id_article == 803 })[0]
        //var objArticle = Me.objet.bddRef.getObjet(article)
        //var dataLigne = Me.objet.bddRef.getObjet("doc_cpt_ligne").mGetNewData()
        //dataLigne.note = ""
        //dataLigne.nom_article = ((article.nom == null) ? "" : article.nom) + " <span style='font-size:80%;'>(" + Me.mGetHebergement().nom + ")</span>"
        //dataLigne.id_article = article.id_article
        //dataLigne.qte = 1
        //dataLigne.id_hebergement = objet.data.id_hebergement
        //dataLigne.date_service = objet.data.date_debut

        //dataLigne.id_tva = Me.objet.bddRef.getObjet("tva").objetMetier.mGetTvaTaux0().id_tva
        //var tauxTva = 0
        //if (Me.objet.bddRef.mGetArray("societe")[0].assujetti_tva == "1") {
        //    var dataTva = objArticle.objetMetier.mGetDataTva()
        //    if (typeof dataTva != 'undefined') {
        //        if (Me.objet.bddRef.mGetArray("societe")[0].assujetti_tva == "1") {
        //            dataLigne.id_tva = dataTva.id_tva
        //            tauxTva = Me.objet.bddRef.getObjet(dataTva).objetMetier.mGetTauxTva()
        //        }
        //    }
        //}
        //   dataLigne.puht = Me.mGetTotalTtcNuite()
        //dataLigne.puttc = Me.mGetTotalTtcNuite()
        //if (tauxTva != 0) dataLigne.puht = Math.round(dataLigne.puht / (1 + tauxTva / 100) * 100) / 100
        //dataLigne.type_remise = 0


        //return dataLigne

        function mGetLstGrpNuite() {
            var lstDate = Me.mGetLstDataReservationHebergementPuttc()
            if (Me.mGetTotalTtcNuite() == (Math.round((Me.mGetTotalTtcNuite() / lstDate.length) * 100) / 100) * lstDate.length) {
                return [{
                    dateDebut: lstDate[0].dat,
                    dateFin: lstDate[lstDate.length - 1].dat,
                    nb: lstDate.length,
                    ttc: (Math.round((Me.mGetTotalTtcNuite() / lstDate.length) * 100) / 100),
                    lstDate: lstDate
                }]
            } else {
                var result = [];
                var debut = 0;
                var somme = 0;
                for (var i = 0; i < lstDate.length; i++) {
                    somme += lstDate[i].puttc;
                    var nb = i - debut + 1;
                    var ttc = Math.round((somme / nb) * 100) / 100;
                    if (Math.round(ttc * nb * 100) !== Math.round(somme * 100)) {
                        // le dernier élément casse la divisibilité
                        var sommePrec = somme - lstDate[i].puttc;
                        var nbPrec = nb - 1;

                        if (nbPrec > 0) {

                            result.push({
                                dateDebut: lstDate[debut].dat,
                                dateFin: lstDate[i - 1].dat,
                                nb: nbPrec,
                                ttc: Math.round((sommePrec / nbPrec) * 100) / 100,
                                lstDate: lstDate.slice(debut, i)
                            });
                        }
                        // nouveau groupe à partir de l'élément courant
                        debut = i;
                        somme = lstDate[i].puttc;
                    }
                }
                // dernier groupe
                if (debut < lstDate.length) {
                    var nb = lstDate.length - debut;
                    var ttc = Math.round((somme / nb) * 100) / 100;
                    result.push({
                        dateDebut: lstDate[debut].dat,
                        dateFin: lstDate[lstDate.length - 1].dat,
                        nb: nb,
                        ttc: ttc,
                        lstDate: lstDate.slice(debut)
                    });
                }
                return result;
            }
        }
    }

    this.mGetGenereLstDocCptLigneService = function () {
        var lstLigne = []
        this.mGetLstDataReservationService().forEach(function (dataResaService) {
            var objResaService = objet.bddRef.getObjet(dataResaService)
            var lstGrpDateNbResaService = objResaService.objetMetier.mGetLstGrpDateNbReservationService()
            if (lstGrpDateNbResaService.length == 0) {
                //pas de date, on ne fait rien
            } else {
                var article = objResaService.objetMetier.mGetDataArticle()
                var objArticle = Me.objet.bddRef.getObjet(article)
                lstGrpDateNbResaService.forEach(function (objGrpDateNbResaService) {
                    var dataLigne = Me.objet.bddRef.getObjet("doc_cpt_ligne").mGetNewData()
                    dataLigne.note = ""
                    dataLigne.id_article = article.id_article
                    dataLigne.id_hebergement = objet.data.id_hebergement
                    dataLigne.date_service = objGrpDateNbResaService.mGetMinDate()
                    dataLigne.qte = objGrpDateNbResaService.mGetTotQte()
                    switch (parseInt(dataResaService.id_article)) {
                        case 801: //taxe sejour adulte
                            dataLigne.qte1 = objGrpDateNbResaService.mGetNbAdulte()
                            dataLigne.qte2 = objGrpDateNbResaService.mGetNbJour()
                            break;
                        case 802: //taxe sejour exo enfant
                            dataLigne.qte1 = objGrpDateNbResaService.mGetNbEnfant()
                            dataLigne.qte2 = objGrpDateNbResaService.mGetNbJour()
                            break;
                        case 805: //taxe sejour exo legale
                            dataLigne.qte1 = objGrpDateNbResaService.mGetNbAdulte()
                            dataLigne.qte2 = objGrpDateNbResaService.mGetNbJour()
                            break;
                    }
                    dataLigne.nom_article = ((article.nom == null) ? "" : article.nom) + " <span style='font-size:80%;'>(" + Me.mGetHebergement().nom + " &bull; " + objGrpDateNbResaService.mGetLibDetailHtmlTooltip() + ")</span>"

                    dataLigne.id_tva = Me.objet.bddRef.getObjet("tva").objetMetier.mGetTvaTaux0().id_tva
                    var tauxTva = 0
                    if (Me.objet.bddRef.mGetArray("societe")[0].assujetti_tva == "1") {
                        var dataTva = objArticle.objetMetier.mGetDataTva()
                        if (typeof dataTva != 'undefined') {
                            if (Me.objet.bddRef.mGetArray("societe")[0].assujetti_tva == "1") {
                                dataLigne.id_tva = dataTva.id_tva
                                tauxTva = Me.objet.bddRef.getObjet(dataTva).objetMetier.mGetTauxTva()
                            }
                        }
                    }
                    switch (parseInt(dataResaService.id_article)) {
                        case 801: //taxe sejour adulte
                        case 802: //taxe sejour exo enfant
                        case 805: //taxe sejour exo legale
                            //on prend le prix en cours de la taxe de séjour
                            dataLigne.puht = objGrpDateNbResaService.dataReservationService.puttc
                            dataLigne.date_service = objGrpDateNbResaService.mGetMaxDate()
                            break;
                        default:
                            dataLigne.puht = objGrpDateNbResaService.mGetTotTtc() / objGrpDateNbResaService.mGetTotQte()
                            break;
                    }

                    //dataLigne.puht = objGrpDateNbResaService.mGetTotTtc() / objGrpDateNbResaService.mGetTotQte()
                    dataLigne.puttc = dataLigne.puht
                    if (tauxTva != 0) dataLigne.puht = Math.round(dataLigne.puht / (1 + tauxTva / 100) * 100) / 100
                    dataLigne.type_remise = 0

                    lstLigne.push(dataLigne)
                })
            }
        })
        return lstLigne
    }

    this.mGetLStServiceParDate = function (date) {
        this.mGetLstDataReservationService().forEach(function (dataResaService) {

        })
    }

}